import { RecommendationKeyEnum } from '$extensionSrc/recommendations/recommendationTypes'
import { StageType } from '$extensionSrc/utils/enums'

import { StageDef } from './automationMachineInterfaces'
import { AUTOMATION_STAGE_STATUSES } from './genericAutomationStageStatuses'

export const getCantUndoFn = () => () => false
export const getCurrentValueFn = () => () => ''
export const getIsDisabledFn = () => () => false
export const getIsDisabledReasonFn = () => () => ''
export const getIsFulfilledFn = () => () => false

export const gatherStageDefs: StageDef[] = []
export const updateStageDefs: StageDef[] = []
export const undoStageDefs: StageDef[] = []

/**
 * Automation stage definition for a manual recommendation.
 *
 * Manual recommendations include a "gather" stage in order to allow it to be
 * reset on full scan if its rescan frequency has passed.
 */
export function generateManualRecommendationGatherStageDef(
  recommendationKey: RecommendationKeyEnum,
): StageDef {
  return {
    type: StageType.ACTION,
    key: `${recommendationKey}_MANUAL_GATHER`,
    status: AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: '',
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      await updateStoredInitialValues({}, recommendationKey)
    },
  }
}
